import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CurrencyPipe } from '../pipes/currency.pipe';

@Directive({
    selector: '[currency]',
    standalone: false
})
export class CurrencyDirective {
  
  private el: HTMLInputElement

  constructor(
    elementRef: ElementRef, 
    private currencyPipe: CurrencyPipe
  ){ 
    this.el = elementRef.nativeElement;
  }

  // @HostListener('click', ['$event.target'])
  // onClick(btn:HTMLButtonElement) {
  //   console.log('button', btn.type, ' *********************************************************** ', this.form?.form.value)

  //   // this.form?.form.value.forEach((element:any) => {
  //   //   console.log('button', btn.name, 'element', element)
  //   // })
  // }

  @HostListener('keyup', ['$event.target.value'])
  onKeyUp(value: string) {
    // console.error('CurrencyDirective -> onKeyUp', value)
    
    this.el.value = this.formatNumber(value)
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    // console.error('CurrencyDirective -> onKeyDown', e)
    if (
      [46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
      // Ctrl+A
      (e.keyCode == 65 && (e.ctrlKey || e.metaKey)) ||
      // Ctrl+C
      (e.keyCode == 67 && (e.ctrlKey || e.metaKey)) ||
      // Ctrl+V
      (e.keyCode == 86 && (e.ctrlKey || e.metaKey)) ||
      // Ctrl+X
      (e.keyCode == 88 && (e.ctrlKey || e.metaKey)) ||
      // Home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }
    // only allow numbers
    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      // console.error('CurrencyDirective -> onKeyDown', 'preventDefault', e.key, e.keyCode)

      e.preventDefault();
    }
  }

  private formatNumber(s: string): string {
    // console.error('CurrencyDirective -> formatNumber', s)
    
    // let n = s.replace(/\D/g, '')

    // let nInteger = parseInt(n.substring(0, n.length-2))
    // if(isNaN(nInteger))
    //   nInteger = 0

    // const nDecimal = n.substring(n.length-2)

    // const value = `${nInteger}.${nDecimal}`

    // console.error('CurrencyDirective -> onKeyDown', 'nInteger', nInteger, 'nDecimal', nDecimal, 'value', value)

    return this.currencyPipe.transform(s)
  }
  
}